enum ConnectionType {
	OneWay = 'one-way',
	RoundTrip = 'round-trip',
	OneWayOrRoundTrip = 'one-way or round-trip',
	AnyDirection = 'any direction'
}

export default ConnectionType;
